import {
  and,
  desc,
  eq,
  follow,
  type PowerSyncDrizzleDB,
  social_notification,
} from "@famidex/powersync";

/**
 * 👥 GRAFO SOCIAL — lecturas local-first [L], aisladas por usuario (los streams
 * `social_follows` / `social_notifications` sólo entregan filas del usuario, así
 * que estas queries no necesitan re-filtrar por privacidad, sólo por rol).
 */

/** "Seguidores": personas que me siguen (soy el followee). */
export function getFollowersQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select()
    .from(follow)
    .where(eq(follow.followee_id, userId))
    .orderBy(desc(follow.created_at));
}

/** "Seguidos": personas a las que sigo (soy el follower). */
export function getFollowingQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select()
    .from(follow)
    .where(eq(follow.follower_id, userId))
    .orderBy(desc(follow.created_at));
}

/** Arista concreta (follower→followee): base del UPDATE-or-INSERT y del estado del botón. */
export function getFollowEdgeQuery(db: PowerSyncDrizzleDB, followerId: string, followeeId: string) {
  return db
    .select()
    .from(follow)
    .where(and(eq(follow.follower_id, followerId), eq(follow.followee_id, followeeId)))
    .limit(1);
}

/** Centro de notificaciones: las mías, más recientes primero. */
export function getNotificationsQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select()
    .from(social_notification)
    .where(eq(social_notification.user_id, userId))
    .orderBy(desc(social_notification.created_at));
}
